import { z } from "zod";

export const visibilityRulesSchema = z.object({
  visibilityRules: z
    .array(z.string())
    .min(1, "At least one visibility rule must be selected"),
});

export type VisibilityRulesFormType = z.infer<typeof visibilityRulesSchema>;
